import React, { useState } from 'react';
import Dialog from './Dialog';
import SectionSelect from './SectionSelect';
import useDialogMutation from '../hooks/useDialogMutation';

function MoveVaultToolDialog({ app, sections, onSubmit, onCreateGroup, onClose }) {
  const [target, setTarget] = useState(sections[0]?.id || '');
  const { run, saving, error } = useDialogMutation();

  return (
    <Dialog title={`Move "${app.name}" to Apps`} onClose={onClose} locked={saving}>
      {sections.length === 0 ? (
        <>
          <p className="dialog-text">Create a group before moving this tool into Apps.</p>
          {error && <p className="dialog-error" role="alert">{error}</p>}
          <div className="dialog-actions">
            <button type="button" className="btn" onClick={onClose}>Cancel</button>
            <button type="button" className="btn btn-primary" onClick={onCreateGroup}>
              Create group
            </button>
          </div>
        </>
      ) : (
        <>
          <span id="vault-move-group-label" className="dialog-label">Group</span>
          <SectionSelect
            labelId="vault-move-group-label"
            sections={sections}
            value={target}
            onChange={setTarget}
          />
          {error && <p className="dialog-error" role="alert">{error}</p>}
          <div className="dialog-actions">
            <button type="button" className="btn" onClick={onClose} disabled={saving}>Cancel</button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={!target || saving}
              onClick={() => run(() => onSubmit(target), onClose)}
            >
              {saving ? 'Moving…' : 'Move to Apps'}
            </button>
          </div>
        </>
      )}
    </Dialog>
  );
}

export default MoveVaultToolDialog;